// removed by extract-text-webpack-plugin
module.exports = {"root":"root___2Qwhk"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/LoadingPage.less
// module id = mQqw
// module chunks = 2